import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTramite, updateEstadoTramite, deleteTramite } from '../services/tramiteService';
import { useAlert } from './useAlert';
export const useDashboard = ({ tramiteId }) => {
  const { errorAlert, questionAlert, successAlert } = useAlert();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [finalizandoTramite, setFinalizandoTramite] = useState(false);
  const [eliminandoTramite, setEliminandoTramite] = useState(false);
  const [tramite, setTramite] = useState(null);

  const finalizarTramite = () => {
    if (tramite) {
      questionAlert({
        title: 'Finalizar trámite',
        text: `¿Esta seguro que desea finalizar el trámite?`,
        icon: 'question'
      }).then(r => {
        if (r.isConfirmed) {
          setFinalizandoTramite(true);
          updateEstadoTramite({
            id: tramite.id,
            estado: 'finalizado'
          }).then(r => {
            successAlert({ message: 'Trámite finalizado con éxito' });
            navigate('/');
          }).catch(err => {
            errorAlert({
              title: 'Error al actualizar trámite',
              exception: err
            });
          }).finally(() => {
            setFinalizandoTramite(false);
          });
        }

      });
    }
  }

  const eliminarTramite = () => {
    if (tramite) {
      questionAlert({
        title: 'Eliminar trámite',
        text: `¿Esta seguro que desea eliminar el trámite?`,
        icon: 'question'
      }).then(r => {
        if (r.isConfirmed) {
          setEliminandoTramite(true);
          deleteTramite({
            id: tramite.id
          }).then(r => {
            successAlert({ message: 'Trámite eliminado con éxito' });
            navigate('/');
          }).catch(err => {
            errorAlert({
              title: 'Error al eliminar trámite',
              exception: err
            });
          }).finally(() => {
            setEliminandoTramite(false);
          });
        }

      });
    }
  }



  const fetchData = ({ silent = false } = {}) => {
    // `silent` evita el flicker de `loading` (que en Dashboard.tsx desmonta todo
    // el contenido, incluidos los diálogos abiertos como el de tareas) cuando el
    // refetch se dispara desde dentro de un modal que debe permanecer abierto.
    if (!silent) {
      setLoading(true);
    }
    getTramite({ id: tramiteId }).then(res => {
      setTramite(res);
    }).catch(err => {
      errorAlert({ exception: err });
      navigate('/');
    }).finally(() => {
      if (!silent) {
        setLoading(false);
      }
    });
  }

  return {
    loading,
    finalizandoTramite,
    eliminandoTramite,
    tramite,
    fetchData,
    finalizarTramite,
    eliminarTramite
  }
}